import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActivateGuard } from './services/guards/activate.guard';
import { FacilityAuthGuard } from './services/guards/facility-auth.guard';
import { LoggedInGuard } from './services/guards/logged-in.guard';
import { DeviceGuard } from './services/guards/device.guard';

const routes: Routes = [
  { path: '',
    pathMatch: 'full',
    redirectTo: 'facility' },
  {
    // This is the login screen and forgot password
    path: 'facility',
    loadChildren: () => import('./web-login/web-login.module').then(m => m.WebLoginModule),
    canActivate: [LoggedInGuard]
  },
  {
    // This is the home view of shifts
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [FacilityAuthGuard, DeviceGuard]
  },
  {
    // This is the dashboard to display open, released and accepted shifts
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [FacilityAuthGuard, DeviceGuard]
  },
  {
    // This is the monthly view of shifts
    path: 'monthly',
    loadChildren: () => import('./monthly-view/monthly-view.module').then(m => m.MonthlyViewModule),
    canActivate: [FacilityAuthGuard, DeviceGuard]
  },
  {
    // This is the week view of shifts
    path: 'week',
    loadChildren: () => import('./week-view/week-view.module').then(m => m.WeekViewModule),
    canActivate: [FacilityAuthGuard, DeviceGuard]
  },
  {
    // This is the requestIntelypro view of shifts
    path: 'request-intelypro',
    loadChildren: () => import('./request-intelypro/request-intelypro.module').then(m => m.RequestIntelyproModule),
    canActivate: [FacilityAuthGuard, DeviceGuard]
  },
  {
    // This is the view of your existing staff
    path: 'directory',
    loadChildren: () => import('./staff-management/staff-management.module').then(m => m.StaffManagementModule),
    canActivate: [FacilityAuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
    canActivate: [FacilityAuthGuard]
  }, {
    path: 'timecards',
    loadChildren: () => import('./timecards/timecards.module').then(m => m.TimecardsModule),
    canActivate: [FacilityAuthGuard]
  },
  {
    path: 'redirect',
    loadChildren: () => import('./wrong-device/wrong-device.module').then(m => m.WrongDeviceModule),
    canActivate: [FacilityAuthGuard, ActivateGuard]
  },
  {
    path: '**',
    redirectTo: 'monthly'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
